import React, { useState } from "react";
import { Avatar } from "antd";
import { EditOutlined, DeleteOutlined } from "@ant-design/icons";
import CustomTable from "../components/Table";

const Termination = () => {
  const [pageSize, setPageSize] = useState(10);
  const [searchText, setSearchText] = useState("");

  const data = [
    {
      key: "1",
      name: "Antony",
      department: "Finance",
      type: "Retirement",
      reason: "Employee Retirement",
      noticeDate: "14 Jan 2024",
      resignDate: "14 Mar 2024",
    },
    {
      key: "2",
      name: "Antony",
      department: "Finance",
      type: "Retirement",
      reason: "Employee Retirement",
      noticeDate: "14 Jan 2024",
      resignDate: "14 Mar 2024",
    },
    {
      key: "3",
      name: "Antony",
      department: "Finance",
      type: "Retirement",
      reason: "Employee Retirement",
      noticeDate: "14 Jan 2024",
      resignDate: "14 Mar 2024",
    },
    {
      key: "4",
      name: "Antony",
      department: "Finance",
      type: "Retirement",
      reason: "Employee Retirement",
      noticeDate: "14 Jan 2024",
      resignDate: "14 Mar 2024",
    },
  ];

  const filteredData = data.filter((item) =>
    item.name.toLowerCase().includes(searchText.toLowerCase())
  );

  const columns = [
    {
      title: "",
      render: () => <input type="checkbox" />,
      width: 50,
    },
    {
      title: "Employee",
      dataIndex: "name",
      render: (text) => (
        <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
          <Avatar src="https://i.pravatar.cc/40" />
          <span>{text}</span>
        </div>
      ),
    },
    {
      title: "Department",
      dataIndex: "department",
    },
    {
      title: "Termination Type",
      dataIndex: "type",
    },
    {
      title: "Reason",
      dataIndex: "reason",
    },
    {
      title: "Notice Date",
      dataIndex: "noticeDate",
    },
    {
      title: "Termination Date", // 🔥 corrected label
      dataIndex: "resignDate",
    },
    {
      title: "Action",
      render: () => (
        <div className="action-icons">
          <EditOutlined />
          <DeleteOutlined />
        </div>
      ),
    },
  ];

  return (
    <CustomTable
      title="Termination List"
      columns={columns}
      data={filteredData}
      pageSize={pageSize}
      setPageSize={setPageSize}
      onSearch={setSearchText}
    />
  );
};

export default Termination;